import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { useCallback } from 'react';
import { Button, ButtonGroup, ClickAwayListener, MenuItem, MenuList, Paper, Popper, } from '@mui/material';
import { ArrowDropDown } from '@mui/icons-material';
import { useRefAnchor } from 'shared/hooks/utils';
export const SplitButton = (props) => {
    const [anchor, ref, open, close] = useRefAnchor();
    const handleToggle = useCallback(() => {
        if (anchor != null) {
            close();
        }
        else {
            open();
        }
    }, [anchor, close, open]);
    return (_jsxs(_Fragment, { children: [_jsxs(ButtonGroup, { variant: "contained", color: "primary", ref: ref, disabled: props.disabled, children: [_jsx(Button, { onClick: props.onClick, children: props.label }), _jsx(Button, { color: "primary", size: "small", onClick: handleToggle, children: _jsx(ArrowDropDown, {}) })] }), _jsx(Popper, { open: !!anchor, anchorEl: anchor, placement: "top-end", sx: { zIndex: 1500 }, children: _jsx(ClickAwayListener, { onClickAway: close, children: _jsx(Paper, { variant: "outlined", square: true, children: _jsx(MenuList, { children: props.options.map((option) => (_jsx(MenuItem, { onClick: () => {
                                    option.onClick();
                                    close();
                                }, style: {
                                    margin: 0,
                                }, disabled: option.disabled, children: option.label }, option.label))) }) }) }) })] }));
};
